import { StyleFunctionProps } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

const baseStyle = (props: StyleFunctionProps) => {
  const { colorScheme: c = 'green' } = props;
  return {
    container: { cursor: 'pointer' },
    label: { cursor: 'pointer' },
    control: {
      cursor: 'pointer',
      _focus: {
        boxShadow: 'none',
      },
      _checked: {
        bg: `${c}.800`,
        borderColor: `${c}.800`,
        _before: {
          w: '52%',
          h: '52%',
          bg: 'white',
        },
      },
      _hover: {
        _checked: {
          bg: `${c}.900`,
          borderColor: `${c}.900`,
        },
      },
    },
  };
};

const sizes = {
  md: {
    control: { w: 6, h: 6 },
    label: { fontSize: 'md' },
  },
  lg: {
    control: { w: 5, h: 5 },
    label: { fontSize: 'md' },
  },
  xl: {
    control: { w: 6, h: 6 },
    label: { fontSize: 'md' },
  },
  '2xl': {
    control: { w: 7, h: 7 },
    label: { fontSize: 'lg' },
  },
};

const cardBase = (props: StyleFunctionProps) => {
  const { colorScheme = 'blue', padding = '3', size = 'lg' } = props;
  return {
    container: {
      position: 'relative',
      zIndex: 1,
      p: padding,
      _hover: {
        opacity: 0.8,
      },
      _before: {
        content: '""',
        position: 'absolute',
        top: '0',
        left: '0',
        height: '100%',
        width: '100%',
        border: 'none',
        borderRadius: 'lg',
        bgColor: 'white',
        zIndex: 0,
      },
      _checked: {
        _before: {
          bg: `blackAlpha.100`,
          borderColor: mode(`${colorScheme}.200`, `${colorScheme}.700`)(props),
        },
      },
    },
    label: {
      zIndex: 1,
    },
    control: {
      zIndex: 1,
      borderWidth: '1px',
      width: sizes[size as keyof typeof sizes].control.w,
      height: sizes[size as keyof typeof sizes].control.h,
    },
  };
};

const variants = {
  card: cardBase,
  cardOutline: (props: StyleFunctionProps) => {
    const styles = cardBase(props);
    return {
      ...styles,
      container: {
        ...styles.container,
        _before: {
          ...styles.container._before,
          bgColor: mode('white', 'gray.800')(props),
          boxSizing: 'border-box',
        },
      },
      control: {
        ...styles.control,
        borderWidth: '2px',
        borderColor: mode('gray.200', 'gray.200')(props),
        _checked: {
          borderColor: mode('green.800', `white`)(props),
          bgColor: mode('green.800', `white`)(props),
          borderWidth: '2px',
          _before: {
            borderColor: mode('', `green.900`)(props),
            bgColor: mode('white', `green.900`)(props),
          },
        },
        _disabled: {
          borderColor: mode('gray.100', 'whiteAlpha.300')(props),
          bgColor: mode('transparent', 'whiteAlpha.300')(props),
        },
      },
    };
  },
};

export default {
  baseStyle,
  sizes,
  variants,
};
